"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationsPlatform = void 0;
var features_1 = require("../features");
Object.defineProperty(exports, "TranslationsPlatform", { enumerable: true, get: function () { return features_1.TranslationsPlatform; } });
//# sourceMappingURL=types.js.map